import UsersTable from "./components/userTable";

const Users = () => {
  return (
    <div className="mt-5 grid h-full  overflow-x-scroll">
      <UsersTable />
    </div>
  );
};

export default Users;
